import React from "react";
import Card, { CardActions, CardContent } from "material-ui/Card";
import CTextField from "uis/CTextField";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";
import BrowserCheck from "components/BrowserCheck";
import ErrorMessage from "components/ErrorMessage";
import AuthError from "components/answer/AuthError";

const browserStyles = theme => ({
  card: {
    margin: `${window.innerHeight / 4}px auto`,
    width: 600,
    backgroundColor: "#fbfbfb"
  },
  title: {
    backgroundColor: theme.palette.primary.light,
    color: "white",
    padding: "10px 8px 6px"
  },
  productName: {
    fontSize: "1.3rem",
    marginLeft: 10,
    letterSpacing: ".3rem"
  },
  cardContent: {
    padding: "50px 50px 30px"
  },
  cardActions: {
    display: "block",
    marginTop: 30,
    textAlign: "center"
  },
  surveyStatusErrorWrapper: {
    width: 600,
    margin: "50px auto",
    padding: 20
  }
});

const mobileStyles = theme => ({
  card: {
    margin: `${window.innerHeight / 4}px 10px`
  },
  title: {
    backgroundColor: theme.palette.primary.light,
    color: "white",
    padding: "5px 10px"
  },
  cardActions: {
    display: "block",
    textAlign: "center"
  }
});

class Login extends React.Component {
  componentWillMount() {
    const { authErrorType, authLogin } = this.props;

    // 認証エラーがある場合(回答中からの認証エラーでの遷移時)は認証しない
    // （再認証するとメッセージがログイン画面用のメッセージに上書きされるので）
    if (!authErrorType) {
      authLogin();
    }
  }

  componentWillUnmount() {
    this.props.init();
  }

  render() {
    const {
      classes,
      authErrorType,
      changeForm,
      handleLogin,
      password,
      errors
    } = this.props;

    return !authErrorType ? (
      <Card className={classes.card}>
        <div className={classes.title}>
          <div className={classes.productName}>NiserES</div>
        </div>

        <CardContent className={classes.cardContent}>
          <BrowserCheck nallow />
          <ErrorMessage messages={errors} />

          <CTextField
            id="password"
            label="パスワード"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={e => changeForm("password", e.target.value)}
            margin="dense"
            fullWidth
          />
        </CardContent>

        <CardActions className={classes.cardActions}>
          <Button raised onClick={() => handleLogin(password)}>
            ログイン
          </Button>
        </CardActions>
      </Card>
    ) : (
      <AuthError authErrorType={authErrorType} />
    );
  }
}

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(Login);



// WEBPACK FOOTER //
// ./src/components/answer/Login.jsx